import React from 'react';
import {Card, Table} from "antd";
import useMortgage from "../../../../../providers/mortgage/useMortgage";
import {MortgageTypes} from "../../../../../../models";
import {extraCosts} from "../lender-tests/useXlsTests";
import {funds as lenderTestFunds} from "../lender-tests/v4/figures-parts/funds";
export function balanceOfFundsCosts(mortgage, override = {}) {
    let {buildType, propertyValue: price, propertyPrice} = mortgage.property
    if (propertyPrice ){
        price = propertyPrice
    }


    if (override.hasOwnProperty('price')) {
        price = override.price
    }
    let {stampDuty, legalFees, totalCosts, propertyValuation} = extraCosts(buildType, price, mortgage.mortgageType===MortgageTypes.REFINANCE)
    return {price, stampDuty, legalFees, propertyValuation, totalCosts}
}

export function balanceOfFundsFunds(mortgage, override = {}) {
    const {totalCosts} = balanceOfFundsCosts(mortgage, override)
    const figures = lenderTestFunds(mortgage)
    const figureValue = (key) => {
        const fig = figures.find(it => it?.namesPath?.[0] === 'funds' && it?.namesPath?.[1] === key)
        const raw = fig?.value
        const amount = raw === null || raw === undefined || Number.isNaN(Number(raw)) ? 0 : Number(raw)
        if (Object.prototype.hasOwnProperty.call(override, key)) {
            return Number(override[key] || 0)
        }
        return amount
    }

    const loan = Object.prototype.hasOwnProperty.call(override, 'loan')
        ? Number(override.loan || 0)
        : (mortgage.activeSubmission?.finalLoan || mortgage.activeSubmission?.provisionalLoan || mortgage.requirement.loanRequired || 0)

    const effectiveValues = {
        loan,
        gifts: figureValue('gifts'),
        helpToBuy: figureValue('helpToBuy'),
        firstHome: figureValue('firstHome'),
        savings: figureValue('savings'),
        bookingDepositPaid: figureValue('bookingDepositPaid'),
        contractDepositPaid: figureValue('contractDepositPaid'),
        sellingProperties: figureValue('profitFromSale'),
        loanClearance: figureValue('loanClearance'),
    }

    const fixedFunds = [
        effectiveValues.loan,
        effectiveValues.gifts,
        effectiveValues.helpToBuy,
        effectiveValues.firstHome,
        effectiveValues.bookingDepositPaid,
        effectiveValues.contractDepositPaid,
        effectiveValues.sellingProperties,
        effectiveValues.loanClearance,
    ].reduce((acc, value) => acc + (value || 0), 0)
    const requiredSavings = Number((totalCosts - fixedFunds).toFixed(2))

    return {
        loan: effectiveValues.loan,
        gifts: effectiveValues.gifts,
        helpToBuy: effectiveValues.helpToBuy,
        firstHome: effectiveValues.firstHome,
        savings: effectiveValues.savings,
        requiredSavings,
        sellingProperties: effectiveValues.sellingProperties,
        bookingDepositPaid: effectiveValues.bookingDepositPaid,
        contractDepositPaid: effectiveValues.contractDepositPaid,
        loanClearance: effectiveValues.loanClearance,
        totalFunds: totalCosts,
        fixedFunds,
        funding: {},
        claimedValues: {},
        provableValues: {},
        effectiveValues,
    }
}
function BalanceOfFunds(props) {
    const mortgage = useMortgage()
    if (!mortgage) return (<div/>)
    //Costs
    const {price, stampDuty, legalFees, totalCosts, propertyValuation} = balanceOfFundsCosts(mortgage)

    const costs = [
        {key: 1, name: "Purchase Price", amount: price},
        {key: 3, name: "Legal Fees", amount: legalFees},
        {key: 4, name: "Valuation", amount: propertyValuation},
    ]
    if (mortgage.mortgageType !== MortgageTypes.REFINANCE) {
        costs.push({key: 2, name: "Stamp Duty", amount: stampDuty})
    }

    //Funds
    const {loan, gifts, helpToBuy, firstHome, bookingDepositPaid, contractDepositPaid, requiredSavings, sellingProperties} = balanceOfFundsFunds(mortgage)
 const funds = []
    if (loan > 0) funds.push({key: 0, name: "Mortgage", amount: loan})
    if (gifts > 0) funds.push({key: 1, name: "Gifts", amount: gifts})
    if (helpToBuy > 0 ) funds.push({key: 2, name: "Help to Buy", amount: helpToBuy})
    if (firstHome > 0 ) funds.push({key: 3, name: "First Home", amount: firstHome})
    if (bookingDepositPaid > 0) funds.push({key: 4, name: "Booking Deposit Paid", amount: bookingDepositPaid})
    if (contractDepositPaid > 0) funds.push({key: 5, name: "Contract Deposit Paid", amount: contractDepositPaid})
    if (sellingProperties > 0) funds.push({key: 7, name: "From Sale of Property", amount: sellingProperties})
    funds.push({key: 6, name: "Savings", amount: requiredSavings})


    //Nicely space the cells so totals are at the bottom
    if (funds.length > costs.length) {
        let diff = funds.length - costs.length
        for (let i = 0; i < diff; i++) {
            costs.push({key: `c.${i}`, name: "", amount: ""})
        }
    }
    else if (costs.length > funds.length) {
        let diff = costs.length - funds.length
        for (let i = 0; i < diff; i++) {
            funds.push({key: `f.${i}`, name: "", amount: ""})
        }
    }
    costs.push({key: 5, name: "TOTAL", amount: totalCosts})
    funds.push({key: 5, name: "TOTAL", amount: totalCosts})

    const columnsCost = [
        {title: "", dataIndex: "name", key: "name"},
        {title: "Costs", dataIndex: "amount", key: "amount", align: "right", render: (text, item) => !text ? '\u00A0': text?.toEuro()}
    ]

    const columnsFunds = [
        {title: "", dataIndex: "name", key: "name"},
        {title: "Funds", dataIndex: "amount", key: "amount", align: "right", render: (text, item) => !text ? '\u00A0' :text?.toEuro()},
    ]
    if (props.contentOnly){
        return (
            <div className="d-row gap-15">
                <Table size="small" dataSource={costs} columns={columnsCost} pagination={false}/>
                <Table size="small" dataSource={funds} columns={columnsFunds} pagination={false}/>
            </div>
        )
    }
    return (

            <Card styles={{body:{padding:0}}} title={ "Balance of Funds"} >
                <div className="d-row gap-15">
                <Table size="small" dataSource={costs} columns={columnsCost} pagination={false}/>
                <Table size="small" dataSource={funds} columns={columnsFunds} pagination={false}/>
                </div>
            </Card>

    );
}

export default BalanceOfFunds;
